import store from '@state/store'

const authRoutes = [
    {
        path: '/',
        name: 'login',
        component: () => import('@views/pages/account/login'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                if (store.getters['auth/loggedIn']) {
                    next({ name: '装修污染控制' })
                } else {
                    next()
                }
            },
        },
    }, 
    {
        path: '/register',
        name: 'register',
        component: () => import('@views/pages/account/register'),
        meta: {  authRequired: false, },
    },     
    {
        path: '/logout',
        name: 'logout',
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                store.dispatch('auth/logOut');
                next({ name: 'login' });
            },
        },
    },
]

const errorPagesRoutes = [
    {
        path: '/404',
        name: '404',
        component: require('@views/pages/secondary/error-404').default,
        props: true,
    },
    {
        path: '/500',
        name: '500',
        component: require('@views/pages/secondary/error-500').default,
        props: true,
    },
    {
        path: '*',
        redirect: '404',
    },
]

const systemAppsRoutes = [
    {
        path: '/solution',
        name: '方案设计',
        icon: 'instagram',        
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
        component: { render(c) { return c('router-view') }, },
        children: [ 
            { 
                path: 'decoration',
                name: '装修污染控制',
                meta: { authRequired: true },
                component: () => loadView(import('@views/pages/solution/decoration/list')), 
            },
        ],
    },
    {
        path: '/construction',
        name: '施工图设计',
        icon: 'map',        
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
        component: { render(c) { return c('router-view') }, },
        children: [ 
            { 
                path: 'decoration',
                name: '装修污染控制',
                meta: { authRequired: true },
                component: () => loadView(import('@views/pages/construction/decoration/list')), 
            },
            {
                path: 'particulate',
                name: '颗粒物污染控制',  
                meta: { authRequired: true },
                component: () => loadView(import('@views/pages/construction/particulate/list')), 
            },
        ],
    },  
    {
        path: '/material',
        name: '建筑材料库',
        icon: 'gift',        
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
        component: () => loadView(import('@views/pages/material/list')),
    },
    {
        path: '/cleanproduct',
        name: '净化产品库',
        icon: 'grid',
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
        component: () => loadView(import('@views/pages/cleanproduct/list')),
    },
    {
        path: '/profile',
        name: '账号信息',
        icon: 'uil-user-circle',
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
        component: () => loadView(import('@views/pages/profile/myprofile')),
    },
    {
        path: '/system',
        name: '系统管理',
        icon: 'settings',
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
        component: { render(c) { return c('router-view') }, },
        children: [ 
            { 
                path: 'user',
                name: '用户管理',
                meta: { authRequired: true },
                component: () => loadView(import('@views/pages/system/user/list')), 
            },   
            {
                path: 'dict',
                name: '字典管理',
                meta: { authRequired: true },
                component: () => loadView(import('@views/pages/system/dict/list')), 
            },          
        ],
    }
];

const otherAppsRoutes = [
    {
        path: 'user',
        name: 'AddUser',
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
        component: () => loadView(import('@views/pages/system/user/add')),
    },
    {
        path: 'user',
        name: 'UpdateUser',
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
        component: () => loadView(import('@views/pages/system/user/update')),
    }, 
    {
        path: 'decoration',
        name: 'AddSolution',
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
        component: () => loadView(import('@views/pages/solution/decoration/add')),
    },
    {
        path: 'decoration',
        name: 'UpdateSolution',
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
        component: () => loadView(import('@views/pages/solution/decoration/update')),
    },
    {
        path: 'decoration',
        name: 'ViewSolutionReport',
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
        component: () => loadView(import('@views/pages/solution/decoration/report')),
    },
    {
        path: 'decoration',
        name: 'AddDecoration',
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
        component: () => loadView(import('@views/pages/construction/decoration/add')),
    }, 
    {
        path: 'decoration',
        name: 'UpdateDecoration',
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
        component: () => loadView(import('@views/pages/construction/decoration/update')),
    },
    {
        path: 'decoration',
        name: 'ViewDecorationReport',
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
        component: () => loadView(import('@views/pages/construction/decoration/report')),
    },   
    {
        path: 'particulate',
        name: 'AddParticulate',
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
        component: () => loadView(import('@views/pages/construction/particulate/add')),
    }, 
    {
        path: 'particulate',
        name: 'UpdateParticulate',
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
        component: () => loadView(import('@views/pages/construction/particulate/update')),
    },      
    {
        path: 'material',
        name: 'AddBuildingMaterial',
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
        component: () => loadView(import('@views/pages/material/add')),
    },
    {
        path: 'material',
        name: 'UpdateBuildingMaterial',
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
        component: () => loadView(import('@views/pages/material/update')),
    },    
    {
        path: 'cleanproduct',
        name: 'AddCleanProduct',
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
        component: () => loadView(import('@views/pages/cleanproduct/add')),
    },
    {
        path: 'cleanproduct',
        name: 'UpdateCleanProduct',
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
        component: () => loadView(import('@views/pages/cleanproduct/update')),
    },
];

const appsRoutes = [
    ...systemAppsRoutes,
]

const allRoutes = [...authRoutes, ...errorPagesRoutes, ...appsRoutes, ...otherAppsRoutes]

export { allRoutes, appsRoutes }

function loadView(AsyncView) {
    const AsyncHandler = () => ({
        component: AsyncView,
        loading: require('@components/_loading').default,
        delay: 5000,
        timeout: 10000,
    })
    return Promise.resolve({
        functional: true,
        render(h, { data, children }) {
            return h(AsyncHandler, data, children)
        },
    })
}